import { Suspense, lazy, useEffect } from "react";
// import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
// import { debounce } from "debounce";
import { Route, Routes, Navigate } from "react-router-dom";
// import store from "store";
// import { saveState } from "store/browser-storage";
import ProtectedRoutes from "guards/ProtectedRoutes";
import Spinner from "components/shared/Spinner";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import VehiclePayment from "pages/Dashboard/Vehicle-Finance/vehiclePayment";
import PaylaterPayment from "pages/Dashboard/PayLater/paylaterPayment";

// const AuthRoutes = lazy(() => import("navigation/AuthRoutes"));
const DashboardRoutes = lazy(() => import("navigation/DashboardRoutes"));
// store.subscribe(
//   // we use debounce to save the state once each 800ms
//   // for better performances in case multiple changes occur in a short time
//   debounce(() => {
//     saveState(store.getState());
//   }, 800)
// );

const SignIn = lazy(() => import("pages/Auth/login/SignIn"));
const SelectCustomerType = lazy(
  () => import("pages/Auth/signup/SelectCustomerType")
);
const Individual = lazy(
  () => import("pages/Auth/signup/individual/Individual")
);
const ForgotPassword = lazy(
  () => import("pages/Auth/forgot-password/ForgotPassword")
);
const Corporate = lazy(() => import("pages/Auth/signup/corporate/Corporate"));

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Suspense
      fallback={
        <div className="code-split">
          <Spinner size="small" />
        </div>
      }
    >
      <ToastContainer />

      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<SignIn />} />
        <Route path="/signup" element={<SelectCustomerType />} />
        <Route path="/signup/individual" element={<Individual />} />
        <Route path="/signup/corporate" element={<Corporate />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route element={<ProtectedRoutes />}>
          <Route path="/*" element={<DashboardRoutes />} />
          <Route
            path="/vehicle-finance/:paymentCode"
            element={<VehiclePayment />}
          />
          <Route
            path="/paylater/:paymentCode"
            element={<PaylaterPayment />}
          />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
